import React from "react";
import HomeCard from "../home/HomeCard";
import Store from "../../content/Store";
import Contentify from "../../content/Contentify";
import { connect } from "react-redux";
import { Paths } from "../../constants/UrlConstants";
import styles from "../../assets/css/modules/health-store/health-store.css";
import c4cStyles from "../../assets/css/modules/health-support/Check4Cancer.css";
import ImageHeroContainer from "../shared/containers/ImageHeroContainer";
import NumberStepList from "../shared/groups/NumberStepList";
import Content from "../../content/Content";
import HelpSectionCancer from "../shared/HelpSectionCancer";


export const mapStateToCheckForCancerSkin = (state) => {
  let policy =
    state && state.policyReducer && state.policyReducer.selectedPolicy;
    const isInternationalOrSaga =
      policy && (policy.IsSaga || policy.IsInternational);
    const isLapsed = policy && policy.IsLapsed;
    const isChildOnly = policy?.IsChildOnlyPolicy;
 
  return {
    isLapsed,
    isInternationalOrSaga,
    IsSME: policy && policy.IsSME,
    IsLargeCorporate: policy && policy.IsLargeCorporate,
    IsIndividual: policy && policy.IsIndividual,
    isSMEModular: policy && policy.IsSMEModular,
    isChildOnly: isChildOnly
  };
};

export const CheckForCancerSkin = function (props) {
  const content = props.content;

  return (
    <React.Fragment>
      {props.IsLargeCorporate ? ( 
        <div>
      <div className="container">
        <div className={"row " + c4cStyles.c4c}>
          <div className="col-sm-12">
            <div className={styles.containerShadow}>
              <ImageHeroContainer
                bgImage={content.HeroBGSrc}
                bgImageMobile={content.HeroBGSrcMobile}
                bgImageTablet={content.HeroBGSrcTablet}
                bgAlt=""
                styleOverrides={c4cStyles}
                Healthsupport1="HealthSupport"
              >
                <h1>{content.Heading}</h1>
                {content.Description}
              </ImageHeroContainer>
              <div className={c4cStyles.steps}>
                <div>
                  <h3>{content.c4cServiceAccess}</h3>
                  {content.ServiceDescription}
                </div>
              </div>
              <div className={c4cStyles.steps}>
                  <h2>{content.c4cProcessHeader}</h2>
                  <div className={c4cStyles.child}>
                  <NumberStepList>
                    {content.discussWithYourGPDetail}
                    {content.callUsDetail}
                    {content.check4CancerDetail}
                  </NumberStepList>
                  </div>
              </div>
              <div className={c4cStyles.steps}>
                <HelpSectionCancer
                  HeadingLinkText={Store.GeneralPages.HelpHeadingLinkText}
                  HeadingLinkTo={Paths.Help}
                  HelpSet={Store.CancerDiagnosticServices.HelpSetCancer.helpSet}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
        {!(props.isInternationalOrSaga || props.isLapsed || props.isChildOnly) ? (
          <div
            className={
              (!(props.isInternationalOrSaga || props.isLapsed || props.isChildOnly)  ? "col-lg-4" : "col-lg-6")
            }
            data-explore-my-cover-home-card
          >
            <Content
              names={[
                Store.CancerDiagnosticServices.Cards.GPAppointment.IconSrc,
                Store.CancerDiagnosticServices.Cards.GPAppointment.Heading,
                Store.CancerDiagnosticServices.Cards.GPAppointment.Description,
                Store.CancerDiagnosticServices.Cards.GPAppointment.LinkText,
                Store.CancerDiagnosticServices.Cards.GPAppointment.LinkTo,
              ]}

            >
              {(iconSrc, heading, description, linktext, linkto) => (
                <HomeCard
                  IconSrc={iconSrc}
                  Heading={heading}
                  Description={description}
                  LinkText={linktext}
                  LinkTo={linkto}
                  Healthsupport1="HealthSupport"
                />
              )}
            </Content>
          </div>
           ) : null}
          <div
            className={
              (!(props.isInternationalOrSaga || props.isLapsed || props.isChildOnly)  ? "col-lg-4" : "col-lg-6")
            }
            data-explore-my-cover-home-card
          >
            <Content
              names={[
                Store.CancerDiagnosticServices.Cards.HealthSupport.IconSrc,
                Store.CancerDiagnosticServices.Cards.HealthSupport.Heading,
                Store.CancerDiagnosticServices.Cards.HealthSupport.Description,
                Store.CancerDiagnosticServices.Cards.HealthSupport.LinkText,
                Store.CancerDiagnosticServices.Cards.HealthSupport.LinkTo,
              ]}
              params={{
                telephoneNumber: props.TelephonePolicyServicing
              }}
            >
              {(iconSrc, heading, description, linktext, linkto) => (
                <HomeCard
                  IconSrc={iconSrc}
                  Heading={heading}
                  Description={description}
                  LinkText={linktext}
                  LinkTo={linkto}
                  Healthsupport1="HealthSupport"
                />
              )}
            </Content>
          </div>

          <div
            className={
              (!(props.isInternationalOrSaga || props.isLapsed || props.isChildOnly)  ? "col-lg-4" : "col-lg-6")
            }
            data-explore-my-cover-home-card
          >
            <Content
              names={[
                Store.CancerDiagnosticServices.Cards.CancerSupport.IconSrc,
                Store.CancerDiagnosticServices.Cards.CancerSupport.Heading,
                Store.CancerDiagnosticServices.Cards.CancerSupport.Description,
                Store.CancerDiagnosticServices.Cards.CancerSupport.LinkText,
                Store.CancerDiagnosticServices.Cards.CancerSupport.LinkTo,
              ]}
            >
              {(iconSrc, heading, description, linktext, linkto) => (
                <HomeCard
                  IconSrc={iconSrc}
                  Heading={heading}
                  Description={description}
                  LinkText={linktext}
                  LinkTo={linkto}
                  ExternalLinkTo={true}
                  Healthsupport1="HealthSupport"
                  externalNav="externalNav"
                />
              )}
            </Content>
          </div>
        </div>
      </div>
      </div>
      ) : null}
      {props.IsIndividual ||  props.IsSME? ( 
        <div>
      <div className="container">
        <div className={"row " + c4cStyles.c4c}>
          <div className="col-sm-12">
            <div className={styles.containerShadow}>
              <ImageHeroContainer
                bgImage={content.HeroBGSrc}
                bgImageMobile={content.HeroBGSrcMobile}
                bgImageTablet={content.HeroBGSrcTablet}
                bgAlt=""
                styleOverrides={c4cStyles}
                Healthsupport1="HealthSupport"
              >
                <h1>{content.Heading}</h1>
                {content.Description}
              </ImageHeroContainer>
              <div className={c4cStyles.steps}>
                <div>
                  <h3>{content.c4cServiceAccess}</h3>
                  {content.ServiceDescriptionIndSME}
                </div>
              </div>
              <div className={c4cStyles.steps}>
                  <h2>{content.c4cProcessHeader}</h2>
               <div className={c4cStyles.child}>
                  <NumberStepList>
                    {content.discussWithYourGPDetail}
                    {content.callUsDetail}
                    {content.check4CancerDetail}
                  </NumberStepList>
                  </div>
              </div>
              <div className={c4cStyles.child}>
              <div className={c4cStyles.steps}>
                <HelpSectionCancer
                  HeadingLinkText={Store.GeneralPages.HelpHeadingLinkText}
                  HeadingLinkTo={Paths.Help}
                  HelpSet={Store.CancerDiagnosticServices.HelpSetCancer.helpSet}
                />
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
        {!(props.isInternationalOrSaga || props.isLapsed || props.isChildOnly) ? (
          <div
            className={
              (!(props.isInternationalOrSaga || props.isLapsed || props.isChildOnly)  ? "col-lg-4" : "col-lg-6")
            }
            data-explore-my-cover-home-card
          >
            <Content
              names={[
                Store.CancerDiagnosticServices.Cards.GPAppointment.IconSrc,
                Store.CancerDiagnosticServices.Cards.GPAppointment.Heading,
                Store.CancerDiagnosticServices.Cards.GPAppointment.Description,
                Store.CancerDiagnosticServices.Cards.GPAppointment.LinkText,
                Store.CancerDiagnosticServices.Cards.GPAppointment.LinkTo,
              ]}

            >
              {(iconSrc, heading, description, linktext, linkto) => (
                <HomeCard
                  IconSrc={iconSrc}
                  Heading={heading}
                  Description={description}
                  LinkText={linktext}
                  LinkTo={linkto}
                  Healthsupport1="HealthSupport"
                />
              )}
            </Content>
          </div>
           ) : null}
          <div
            className={
              (!(props.isInternationalOrSaga || props.isLapsed || props.isChildOnly)  ? "col-lg-4" : "col-lg-6")
            }
            data-explore-my-cover-home-card
          >
            <Content
              names={[
                Store.CancerDiagnosticServices.Cards.HealthSupport.IconSrc,
                Store.CancerDiagnosticServices.Cards.HealthSupport.Heading,
                Store.CancerDiagnosticServices.Cards.HealthSupport.Description,
                Store.CancerDiagnosticServices.Cards.HealthSupport.LinkText,
                Store.CancerDiagnosticServices.Cards.HealthSupport.LinkTo,
              ]}
              params={{
                telephoneNumber: props.TelephonePolicyServicing
              }}
            >
              {(iconSrc, heading, description, linktext, linkto) => (
                <HomeCard
                  IconSrc={iconSrc}
                  Heading={heading}
                  Description={description}
                  LinkText={linktext}
                  LinkTo={linkto}
                  Healthsupport1="HealthSupport"
                />
              )}
            </Content>
          </div>

          <div
            className={
              (!(props.isInternationalOrSaga || props.isLapsed || props.isChildOnly)  ? "col-lg-4" : "col-lg-6")
            }
            data-explore-my-cover-home-card
          >
            <Content
              names={[
                Store.CancerDiagnosticServices.Cards.CancerSupport.IconSrc,
                Store.CancerDiagnosticServices.Cards.CancerSupport.Heading,
                Store.CancerDiagnosticServices.Cards.CancerSupport.Description,
                Store.CancerDiagnosticServices.Cards.CancerSupport.LinkText,
                Store.CancerDiagnosticServices.Cards.CancerSupport.LinkTo,
              ]}
              params={{
                telephoneNumber: props.TelephonePolicyServicing
              }}
            >
              {(iconSrc, heading, description, linktext, linkto) => (
                <HomeCard
                  IconSrc={iconSrc}
                  Heading={heading}
                  Description={description}
                  LinkText={linktext}
                  LinkTo={linkto}
                  ExternalLinkTo={true}
                  Healthsupport1="HealthSupport"
                  externalNav="externalNav"
                />
              )}
            </Content>
          </div>
        </div>
      </div>
      </div>
      ) 
      :null}
    </React.Fragment>
  );
};

CheckForCancerSkin.content = Store.Check4CancerSkin;

export default connect(mapStateToCheckForCancerSkin)(Contentify(CheckForCancerSkin));
